import { render, staticRenderFns } from "./ceping.vue?vue&type=template&id=5ef90d98&scoped=true&"
import script from "./ceping.vue?vue&type=script&lang=ts&"
export * from "./ceping.vue?vue&type=script&lang=ts&"
import style0 from "./ceping.vue?vue&type=style&index=0&id=5ef90d98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef90d98",
  null
  
)

export default component.exports